import {Component} from '@angular/core';
import {UserModelInterfaces} from '../../interfaces/responses/user-model.interfaces';

@Component({
  selector: 'app-single-user-profile',
  imports: [],
  templateUrl: './single-user-profile.component.html',
  styleUrl: './single-user-profile.component.scss'
})
export class SingleUserProfileComponent {

  userData: UserModelInterfaces = {
    accessToken: '',
    exp: '',
    firstLogin: false,
    user: {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      roles: []
    }
  };

  ngOnInit(): void {
    if (typeof window === 'undefined') return;
    const raw = localStorage.getItem('userInfo');
    if (raw) {
      this.userData = JSON.parse(raw);
    }
  }
}
